export const CalendarIcon = ({
  color = "white",
  width = 17,
  height = 16,
  strokeWidth = 1.333,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      d="M6.18484 1.33333V3.99999"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5182 1.33333V3.99999"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5182 2.66667H4.18483C3.44846 2.66667 2.8515 3.26363 2.8515 4.00001V13.3333C2.8515 14.0697 3.44846 14.6667 4.18483 14.6667H13.5182C14.2545 14.6667 14.8515 14.0697 14.8515 13.3333V4.00001C14.8515 3.26363 14.2545 2.66667 13.5182 2.66667Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.8515 6.66667H14.8515"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UtensilsIcon = ({
  color = "blue",
  width = 24,
  height = 24,
  strokeWidth = 1.5,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" />
    <path d="M7 2v20" />
    <path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Z" />
    <path d="M21 15v7" />
  </svg>
);

export const LayersIcon = ({
  color = "#9810FA",
  width = 20,
  height = 20,
  strokeWidth = 1.67,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <g clipPath="url(#clip0_10_965)">
      <path d="M10.6917 1.81668C10.4745 1.71764 10.2387 1.66638 10 1.66638C9.76135 1.66638 9.52548 1.71764 9.30834 1.81668L2.16668 5.06668C2.0188 5.13188 1.89308 5.23868 1.80481 5.37406C1.71655 5.50944 1.66956 5.66757 1.66956 5.82918C1.66956 5.99079 1.71655 6.14892 1.80481 6.2843C1.89308 6.41968 2.0188 6.52648 2.16668 6.59168L9.31668 9.85001C9.53381 9.94905 9.76969 10.0003 10.0083 10.0003C10.247 10.0003 10.4829 9.94905 10.7 9.85001L17.85 6.60001C17.9979 6.53481 18.1236 6.42801 18.2119 6.29263C18.3001 6.15725 18.3471 5.99913 18.3471 5.83751C18.3471 5.6759 18.3001 5.51777 18.2119 5.38239C18.1236 5.24701 17.9979 5.14022 17.85 5.07501L10.6917 1.81668Z" />
      <path d="M1.66666 10C1.66626 10.1594 1.71159 10.3155 1.79726 10.45C1.88292 10.5844 2.00534 10.6914 2.14999 10.7583L9.31666 14.0167C9.53266 14.1145 9.76704 14.1651 10.0042 14.1651C10.2413 14.1651 10.4757 14.1145 10.6917 14.0167L17.8417 10.7667C17.9892 10.7004 18.1142 10.5926 18.2015 10.4564C18.2888 10.3203 18.3346 10.1617 18.3333 10" />
      <path d="M1.66666 14.1667C1.66626 14.3261 1.71159 14.4822 1.79726 14.6166C1.88292 14.7511 2.00534 14.8581 2.14999 14.925L9.31666 18.1834C9.53266 18.2812 9.76704 18.3318 10.0042 18.3318C10.2413 18.3318 10.4757 18.2812 10.6917 18.1834L17.8417 14.9334C17.9892 14.8671 18.1142 14.7593 18.2015 14.6231C18.2888 14.487 18.3346 14.3284 18.3333 14.1667" />
    </g>
    <defs>
      <clipPath id="clip0_10_965">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UploadIcon = ({
  color = "#99A1AF",
  width = 33,
  height = 33,
  strokeWidth = 2.67,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 33 33"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16.75 4.75V20.75" />
    <path d="M23.4167 11.4167L16.75 4.75L10.0833 11.4167" />
    <path d="M28.75 20.75V26.0833C28.75 26.7906 28.469 27.4689 27.969 27.969C27.4689 28.469 26.7906 28.75 26.0833 28.75H7.41667C6.70942 28.75 6.03115 28.469 5.53105 27.969C5.03095 27.4689 4.75 26.7906 4.75 26.0833V20.75" />
  </svg>
);

export const ImageIcon = ({
  color = "#00A63E",
  width = 20,
  height = 20,
  strokeWidth = 1.67,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M15.8333 2.5H4.16667C3.24619 2.5 2.5 3.24619 2.5 4.16667V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5Z" />
    <path d="M7.50001 9.16665C8.42048 9.16665 9.16668 8.42045 9.16668 7.49998C9.16668 6.57951 8.42048 5.83331 7.50001 5.83331C6.57954 5.83331 5.83334 6.57951 5.83334 7.49998C5.83334 8.42045 6.57954 9.16665 7.50001 9.16665Z" />
    <path d="M17.5 12.5L14.9283 9.92835C14.6158 9.61589 14.1919 9.44037 13.75 9.44037C13.3081 9.44037 12.8842 9.61589 12.5717 9.92835L5 17.5" />
  </svg>
);

export const CurrencyIcon = ({
  color = "#F54900",
  width = 20,
  height = 20,
  strokeWidth = 1.67,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M10 1.66663V18.3333" />
    <path d="M14.1667 4.16663H7.91667C7.14312 4.16663 6.40125 4.47392 5.85427 5.0209C5.30729 5.56788 5 6.30974 5 7.08329C5 7.85684 5.30729 8.59871 5.85427 9.14569C6.40125 9.69267 7.14312 9.99996 7.91667 9.99996H12.0833C12.8569 9.99996 13.5987 10.3073 14.1457 10.8542C14.6927 11.4012 15 12.1431 15 12.9166C15 13.6902 14.6927 14.432 14.1457 14.979C13.5987 15.526 12.8569 15.8333 12.0833 15.8333H5" />
  </svg>
);

export const BoxIcon = ({
  color = "#4F39F6",
  width = 20,
  height = 20,
  strokeWidth = 1.67,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M9.16667 18.1084C9.42003 18.2547 9.70744 18.3317 10 18.3317C10.2926 18.3317 10.58 18.2547 10.8333 18.1084L16.6667 14.7751C16.9198 14.6289 17.13 14.4188 17.2763 14.1658C17.4225 13.9127 17.4997 13.6257 17.5 13.3334V6.66675C17.4997 6.37448 17.4225 6.08742 17.2763 5.83438C17.13 5.58134 16.9198 5.37122 16.6667 5.22508L10.8333 1.89175C10.58 1.74547 10.2926 1.66846 10 1.66846C9.70744 1.66846 9.42003 1.74547 9.16667 1.89175L3.33333 5.22508C3.08022 5.37122 2.86998 5.58134 2.72372 5.83438C2.57745 6.08742 2.5003 6.37448 2.5 6.66675V13.3334C2.5003 13.6257 2.57745 13.9127 2.72372 14.1658C2.86998 14.4188 3.08022 14.6289 3.33333 14.7751L9.16667 18.1084Z" />
    <path d="M10 18.3333V10" />
    <path d="M2.74167 5.83337L10 10L17.2583 5.83337" />
    <path d="M6.25 3.55835L13.75 7.85002" />
  </svg>
);

export const CartIcon = ({
  color = "#D08700",
  width = 20,
  height = 20,
  strokeWidth = 1.67,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M6.66668 18.3334C7.12691 18.3334 7.50001 17.9603 7.50001 17.5001C7.50001 17.0398 7.12691 16.6667 6.66668 16.6667C6.20644 16.6667 5.83334 17.0398 5.83334 17.5001C5.83334 17.9603 6.20644 18.3334 6.66668 18.3334Z" />
    <path d="M15.8333 18.3334C16.2936 18.3334 16.6667 17.9603 16.6667 17.5001C16.6667 17.0398 16.2936 16.6667 15.8333 16.6667C15.3731 16.6667 15 17.0398 15 17.5001C15 17.9603 15.3731 18.3334 15.8333 18.3334Z" />
    <path d="M1.70831 1.7085H3.37498L5.59165 12.0585C5.67296 12.4375 5.88387 12.7764 6.18807 13.0167C6.49227 13.257 6.87073 13.3838 7.25831 13.3752H15.4083C15.7876 13.3745 16.1554 13.2446 16.4508 13.0067C16.7463 12.7688 16.9518 12.4373 17.0333 12.0668L18.4083 5.87516H4.26665" />
  </svg>
);

export const ClockIcon = ({
  color = "#009689",
  width = 20,
  height = 20,
  strokeWidth = 1.667,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M10 5V10L13.3333 11.6667" />
    <path d="M9.99999 18.3334C14.6024 18.3334 18.3333 14.6025 18.3333 10.0001C18.3333 5.39771 14.6024 1.66675 9.99999 1.66675C5.39762 1.66675 1.66666 5.39771 1.66666 10.0001C1.66666 14.6025 5.39762 18.3334 9.99999 18.3334Z" />
  </svg>
);

export const PlusIcon = ({
  color = "#E7000B",
  width = 20,
  height = 20,
  strokeWidth = 1.667,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4.16666 10H15.8333" />
    <path d="M10 4.16675V15.8334" />
  </svg>
);
export const EditIconSquare = ({
  color = "#155DFC",
  width = 16,
  height = 16,
  strokeWidth = 1.333,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* The Square/Paper Path */}
    <path d="M8 2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8" />

    {/* The Pencil Path */}
    <path d="M12.25 1.75C12.5152 1.48478 12.8749 1.33578 13.25 1.33578C13.625 1.33578 13.9847 1.48478 14.25 1.75C14.5152 2.01521 14.6642 2.37493 14.6642 2.75C14.6642 3.12507 14.5152 3.48478 14.25 3.75L8.24129 9.75933C8.08299 9.9175 7.88743 10.0333 7.67263 10.096L5.75729 10.656C5.69993 10.6727 5.63912 10.6737 5.58123 10.6589C5.52335 10.6441 5.47051 10.614 5.42826 10.5717C5.386 10.5294 5.35589 10.4766 5.34106 10.4187C5.32623 10.3608 5.32723 10.3 5.34396 10.2427L5.90396 8.32733C5.96698 8.1127 6.08298 7.91737 6.24129 7.75933L12.25 1.75Z" />
  </svg>
);
export const TrashIcon = ({
  color = "#E7000B",
  width = 16,
  height = 16,
  strokeWidth = 1.333,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M6.66669 7.33325V11.3333" />
    <path d="M9.33331 7.33325V11.3333" />
    <path d="M12.6666 4V13.3333C12.6666 13.687 12.5262 14.0261 12.2761 14.2761C12.0261 14.5262 11.6869 14.6667 11.3333 14.6667H4.66665C4.31302 14.6667 3.97389 14.5262 3.72384 14.2761C3.47379 14.0261 3.33331 13.687 3.33331 13.3333V4" />
    <path d="M2 4H14" />
    <path d="M5.33331 3.99992V2.66659C5.33331 2.31296 5.47379 1.97382 5.72384 1.72378C5.97389 1.47373 6.31302 1.33325 6.66665 1.33325H9.33331C9.68694 1.33325 10.0261 1.47373 10.2761 1.72378C10.5262 1.97382 10.6666 2.31296 10.6666 2.66659V3.99992" />
  </svg>
);

export const FileIcon = ({
  color = "white",
  width = 16,
  height = 16,
  strokeWidth = 1.333,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M10.1333 2C10.485 2.00501 10.8205 2.14878 11.0667 2.4L13.6 4.93333C13.8512 5.17951 13.995 5.51497 14 5.86667V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H10.1333Z" />
    <path d="M11.3334 14.0001V9.33341C11.3334 9.1566 11.2631 8.98703 11.1381 8.86201C11.0131 8.73699 10.8435 8.66675 10.6667 8.66675H5.33335C5.15654 8.66675 4.98697 8.73699 4.86195 8.86201C4.73693 8.98703 4.66669 9.1566 4.66669 9.33341V14.0001" />
    <path d="M4.66669 2V4.66667C4.66669 4.84348 4.73693 5.01305 4.86195 5.13807C4.98697 5.2631 5.15654 5.33333 5.33335 5.33333H10" />
  </svg>
);

export const ShieldCheckIcon = ({
  color = "#00A63E",
  width = 20,
  height = 20,
  strokeWidth = 1.667,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16.6667 10.8333C16.6667 15 13.75 17.0833 10.2833 18.2916C10.1018 18.3532 9.90462 18.3502 9.72501 18.2833C6.25001 17.0833 3.33334 15 3.33334 10.8333V4.99997C3.33334 4.77895 3.42114 4.56699 3.57742 4.41071C3.7337 4.25443 3.94566 4.16663 4.16668 4.16663C5.83334 4.16663 7.91668 3.16663 9.36668 1.89997C9.54322 1.74913 9.7678 1.66626 10 1.66626C10.2322 1.66626 10.4568 1.74913 10.6333 1.89997C12.0917 3.17497 14.1667 4.16663 15.8333 4.16663C16.0544 4.16663 16.2663 4.25443 16.4226 4.41071C16.5789 4.56699 16.6667 4.77895 16.6667 4.99997V10.8333Z" />
    <path d="M7.5 10L9.16667 11.6667L12.5 8.33337" />
  </svg>
);

export const UsersIcon = ({
  color = "#6A7282",
  width = 16,
  height = 16,
  strokeWidth = 1.333,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M11.1667 14V12.6667C11.1667 11.9594 10.8857 11.2811 10.3856 10.781C9.88552 10.281 9.20724 10 8.5 10H4.5C3.79275 10 3.11448 10.281 2.61438 10.781C2.11428 11.2811 1.83333 11.9594 1.83333 12.6667V14" />
    <path d="M11.1667 2.08534C11.7385 2.23359 12.2449 2.56752 12.6065 3.03472C12.968 3.50192 13.1641 4.07594 13.1641 4.66668C13.1641 5.25742 12.968 5.83144 12.6065 6.29863C12.2449 6.76583 11.7385 7.09976 11.1667 7.24801" />
    <path d="M15.1667 14V12.6667C15.1662 12.0758 14.9696 11.5019 14.6076 11.0349C14.2456 10.5679 13.7388 10.2344 13.1667 10.0867" />
    <path d="M6.5 7.33333C7.97276 7.33333 9.16667 6.13943 9.16667 4.66667C9.16667 3.19391 7.97276 2 6.5 2C5.02724 2 3.83333 3.19391 3.83333 4.66667C3.83333 6.13943 5.02724 7.33333 6.5 7.33333Z" />
  </svg>
);

export const CreditCardIcon = ({
  color = "#155DFC",
  width = 20,
  height = 20,
  strokeWidth = 1.667,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16.6667 4.16663H3.33335C2.41288 4.16663 1.66669 4.91282 1.66669 5.83329V14.1666C1.66669 15.0871 2.41288 15.8333 3.33335 15.8333H16.6667C17.5872 15.8333 18.3334 15.0871 18.3334 14.1666V5.83329C18.3334 4.91282 17.5872 4.16663 16.6667 4.16663Z" />
    <path d="M1.66669 8.33337H18.3334" />
  </svg>
);

export const TruckIcon = ({
  color = "#F54900",
  width = 20,
  height = 20,
  strokeWidth = 1.667,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M11.6667 15V5.00004C11.6667 4.55801 11.4911 4.13409 11.1785 3.82153C10.866 3.50897 10.442 3.33337 10 3.33337H3.33335C2.89133 3.33337 2.4674 3.50897 2.15484 3.82153C1.84228 4.13409 1.66669 4.55801 1.66669 5.00004V14.1667C1.66669 14.3877 1.75448 14.5997 1.91076 14.756C2.06704 14.9122 2.27901 15 2.50002 15H4.16669" />
    <path d="M12.5 15H7.5" />
    <path d="M15.8334 15H17.5C17.721 15 17.933 14.9122 18.0893 14.7559C18.2456 14.5996 18.3334 14.3876 18.3334 14.1666V11.125C18.333 10.9358 18.2684 10.7525 18.15 10.605L15.25 6.97996C15.1721 6.88236 15.0732 6.80353 14.9607 6.74929C14.8482 6.69506 14.7249 6.6668 14.6 6.66663H11.6667" />
    <path d="M14.1667 16.6667C15.0871 16.6667 15.8333 15.9205 15.8333 15C15.8333 14.0796 15.0871 13.3334 14.1667 13.3334C13.2462 13.3334 12.5 14.0796 12.5 15C12.5 15.9205 13.2462 16.6667 14.1667 16.6667Z" />
    <path d="M5.83335 16.6667C6.75383 16.6667 7.50002 15.9205 7.50002 15C7.50002 14.0796 6.75383 13.3334 5.83335 13.3334C4.91288 13.3334 4.16669 14.0796 4.16669 15C4.16669 15.9205 4.91288 16.6667 5.83335 16.6667Z" />
  </svg>
);

export const NotificationIcon = ({
  stroke = "#0A0A0A",
  width = 16,
  height = 16,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.84534 14C6.96237 14.2027 7.13068 14.371 7.33337 14.488C7.53605 14.605 7.76597 14.6666 8 14.6666C8.23404 14.6666 8.46396 14.605 8.66664 14.488C8.86933 14.371 9.03764 14.2027 9.15467 14"
      stroke={stroke}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.17467 10.2173C2.08758 10.3128 2.0301 10.4315 2.00924 10.559C1.98837 10.6865 2.00501 10.8174 2.05714 10.9356C2.10926 11.0538 2.19462 11.1544 2.30284 11.225C2.41105 11.2956 2.53745 11.3332 2.66667 11.3333H13.3333C13.4625 11.3334 13.589 11.2959 13.6972 11.2254C13.8055 11.1549 13.891 11.0545 13.9433 10.9363C13.9955 10.8182 14.0123 10.6874 13.9916 10.5599C13.9709 10.4323 13.9136 10.3136 13.8267 10.218C12.94 9.304 12 8.33267 12 5.33333C12 4.27247 11.5786 3.25505 10.8284 2.50491C10.0783 1.75476 9.06087 1.33333 8 1.33333C6.93914 1.33333 5.92172 1.75476 5.17157 2.50491C4.42143 3.25505 4 4.27247 4 5.33333C4 8.33267 3.05933 9.304 2.17467 10.2173Z"
      stroke={stroke}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FolderIcon = ({
  color = "#9810FA",
  width = 32,
  height = 32,
  strokeWidth = 2.66667,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00002 18.6668L10 14.8001C10.2175 14.3683 10.5482 14.0037 10.9568 13.7454C11.3655 13.487 11.8367 13.3447 12.32 13.3335H26.6667M26.6667 13.3335C27.0741 13.3327 27.4762 13.4254 27.8422 13.6042C28.2082 13.7831 28.5284 14.0434 28.7781 14.3653C29.0279 14.6871 29.2006 15.0619 29.2829 15.4609C29.3653 15.8598 29.3552 16.2724 29.2534 16.6668L27.2 24.6668C27.0515 25.2422 26.715 25.7515 26.2439 26.1139C25.7729 26.4762 25.1943 26.6708 24.6 26.6668H5.33335C4.62611 26.6668 3.94783 26.3858 3.44774 25.8857C2.94764 25.3856 2.66669 24.7074 2.66669 24.0001V6.66679C2.66669 5.95955 2.94764 5.28127 3.44774 4.78118C3.94783 4.28108 4.62611 4.00013 5.33335 4.00013H10.5334C10.9793 3.99576 11.4193 4.10331 11.813 4.31295C12.2066 4.5226 12.5414 4.82763 12.7867 5.20013L13.8667 6.80013C14.1095 7.16883 14.4401 7.47149 14.8287 7.68093C15.2173 7.89038 15.6519 8.00006 16.0934 8.00013H24C24.7073 8.00013 25.3855 8.28108 25.8856 8.78118C26.3857 9.28127 26.6667 9.95955 26.6667 10.6668V13.3335Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DeleteIcon = ({
  color = "#D4183D",
  width = 37,
  height = 33,
  strokeWidth = 1.33333,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 37 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.526 15.8333V19.8333"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.1927 15.8333V19.8333"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.5261 12.5V21.8333C23.5261 22.187 23.3856 22.5261 23.1356 22.7761C22.8855 23.0262 22.5464 23.1667 22.1927 23.1667H15.5261C15.1725 23.1667 14.8333 23.0262 14.5833 22.7761C14.3332 22.5261 14.1927 22.187 14.1927 21.8333V12.5"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8594 12.5H24.8594"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.1927 12.5V11.1667C16.1927 10.8131 16.3332 10.4739 16.5833 10.2239C16.8333 9.97382 17.1725 9.83334 17.5261 9.83334H20.1927C20.5464 9.83334 20.8855 9.97382 21.1356 10.2239C21.3856 10.4739 21.5261 10.8131 21.5261 11.1667V12.5"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EyeOffIcon = ({
  color = "#D4183D",
  width = 24,
  height = 24,
  strokeWidth = 1.33333,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49" />
    <path d="M14.084 14.158a3 3 0 0 1-4.242-4.242" />
    <path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143" />
    <path d="m2 2 20 20" />
  </svg>
);

export const EditIcon = ({
  color = "#155DFC",
  width = 37,
  height = 33,
  strokeWidth = 1.33333,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 37 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4_304)">
      <path
        d="M24.9754 13.0414C25.3278 12.689 25.5259 12.211 25.526 11.7126C25.526 11.2142 25.3281 10.7362 24.9757 10.3837C24.6233 10.0312 24.1453 9.83316 23.6469 9.8331C23.1485 9.83304 22.6705 10.031 22.318 10.3834L13.4207 19.2827C13.2659 19.437 13.1514 19.627 13.0874 19.836L12.2067 22.7374C12.1895 22.795 12.1882 22.8563 12.2029 22.9146C12.2177 22.9729 12.248 23.0262 12.2906 23.0687C12.3332 23.1112 12.3865 23.1414 12.4448 23.1561C12.5032 23.1707 12.5644 23.1693 12.622 23.152L15.524 22.272C15.7328 22.2085 15.9228 22.0947 16.0774 21.9407L24.9754 13.0414Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4_304">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(10.8594 8.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const InfoIcon = ({
  color = "white",
  width = 20,
  height = 20,
  strokeWidth = 1.66667,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99996 18.3333C14.6023 18.3333 18.3333 14.6024 18.3333 9.99999C18.3333 5.39762 14.6023 1.66666 9.99996 1.66666C5.39759 1.66666 1.66663 5.39762 1.66663 9.99999C1.66663 14.6024 5.39759 18.3333 9.99996 18.3333Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 6.66666V9.99999"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 13.3333H10.0083"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ErrorIcon = ({
  color = "#E7000B",
  width = 20,
  height = 20,
  strokeWidth = 1.66667,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99996 18.3333C14.6023 18.3333 18.3333 14.6024 18.3333 9.99999C18.3333 5.39762 14.6023 1.66666 9.99996 1.66666C5.39759 1.66666 1.66663 5.39762 1.66663 9.99999C1.66663 14.6024 5.39759 18.3333 9.99996 18.3333Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 7.5L7.5 12.5"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 7.5L12.5 12.5"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AlertIcon = ({
  color = "#C10007",
  width = 20,
  height = 20,
  strokeWidth = 1.66667,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6667 10.8333C16.6667 15 13.75 17.0833 10.2834 18.2917C10.1018 18.3532 9.90466 18.3502 9.72504 18.2833C6.25004 17.0833 3.33337 15 3.33337 10.8333V5C3.33337 4.77898 3.42117 4.56702 3.57745 4.41074C3.73373 4.25446 3.94569 4.16667 4.16671 4.16667C5.83337 4.16667 7.91671 3.16666 9.36671 1.9C9.54325 1.74916 9.76784 1.66629 10 1.66629C10.2322 1.66629 10.4568 1.74916 10.6334 1.9C12.0917 3.175 14.1667 4.16667 15.8334 4.16667C16.0544 4.16667 16.2663 4.25446 16.4226 4.41074C16.5789 4.56702 16.6667 4.77898 16.6667 5V10.8333Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 6.66666V9.99999"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 13.3333H10.0083"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DisableIcon = ({
  color = "#9810FA",
  width = 20,
  height = 20,
  strokeWidth = 1.66667,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.10754 4.10748L15.8917 15.8925"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99996 18.3334C14.6023 18.3334 18.3333 14.6024 18.3333 10C18.3333 5.39765 14.6023 1.66669 9.99996 1.66669C5.39759 1.66669 1.66663 5.39765 1.66663 10C1.66663 14.6024 5.39759 18.3334 9.99996 18.3334Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HomeAddIcon = ({
  color = "#155DFC",
  width = 20,
  height = 20,
  strokeWidth = 1.66667,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3334 13.3333H18.3334"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8334 10.8333V15.8333"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 8.33335V6.66669C17.4997 6.37442 17.4225 6.08736 17.2763 5.83432C17.13 5.58128 16.9198 5.37116 16.6667 5.22502L10.8333 1.89169C10.58 1.74541 10.2926 1.6684 10 1.6684C9.70744 1.6684 9.42003 1.74541 9.16667 1.89169L3.33333 5.22502C3.08022 5.37116 2.86998 5.58128 2.72372 5.83432C2.57745 6.08736 2.5003 6.37442 2.5 6.66669V13.3334C2.5003 13.6256 2.57745 13.9127 2.72372 14.1657C2.86998 14.4188 3.08022 14.6289 3.33333 14.775L9.16667 18.1084C9.42003 18.2546 9.70744 18.3316 10 18.3316C10.2926 18.3316 10.58 18.2546 10.8333 18.1084L12.5 17.1584"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.25 3.55835L13.75 7.85002"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.7417 5.83331L10 9.99998L17.2584 5.83331"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 18.3333V10"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HomeRemoveIcon = ({
  color = "white",
  width = 20,
  height = 20,
  strokeWidth = 1.7,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_81_830)">
      <path
        d="M17.8501 8.50001V6.80001C17.8497 6.50189 17.7711 6.2091 17.6219 5.951C17.4727 5.6929 17.2582 5.47857 17.0001 5.32951L11.0501 1.92951C10.7916 1.7803 10.4985 1.70175 10.2001 1.70175C9.90164 1.70175 9.60848 1.7803 9.35005 1.92951L3.40005 5.32951C3.14187 5.47857 2.92743 5.6929 2.77824 5.951C2.62905 6.2091 2.55035 6.50189 2.55005 6.80001V13.6C2.55035 13.8981 2.62905 14.1909 2.77824 14.449C2.92743 14.7071 3.14187 14.9215 3.40005 15.0705L9.35005 18.4705C9.60848 18.6197 9.90164 18.6983 10.2001 18.6983C10.4985 18.6983 10.7916 18.6197 11.0501 18.4705L12.7501 17.5015"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.375 3.62949L14.025 8.00699"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.79651 5.95001L10.2 10.2L17.6035 5.95001"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2001 18.7V10.2"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4501 11.05L18.7001 15.3M14.4501 15.3L18.7001 11.05"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_81_830">
        <rect width="20.4" height="20.4" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const GiftIcon = ({
  color = "#00A63E",
  width = 20,
  height = 20,
  strokeWidth = 1.66667,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6667 6.66663H3.33333C2.8731 6.66663 2.5 7.03972 2.5 7.49996V9.16663C2.5 9.62686 2.8731 9.99996 3.33333 9.99996H16.6667C17.1269 9.99996 17.5 9.62686 17.5 9.16663V7.49996C17.5 7.03972 17.1269 6.66663 16.6667 6.66663Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 6.66663V17.5"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8333 10V15.8333C15.8333 16.2754 15.6577 16.6993 15.3451 17.0118C15.0326 17.3244 14.6087 17.5 14.1666 17.5H5.83329C5.39127 17.5 4.96734 17.3244 4.65478 17.0118C4.34222 16.6993 4.16663 16.2754 4.16663 15.8333V10"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.24996 6.66667C5.69743 6.66667 5.16752 6.44717 4.77682 6.05647C4.38612 5.66577 4.16663 5.13587 4.16663 4.58333C4.16663 4.0308 4.38612 3.50089 4.77682 3.11019C5.16752 2.71949 5.69743 2.5 6.24996 2.5C7.05386 2.48599 7.84165 2.87605 8.51057 3.6193C9.1795 4.36255 9.69852 5.4245 9.99996 6.66667C10.3014 5.4245 10.8204 4.36255 11.4893 3.6193C12.1583 2.87605 12.9461 2.48599 13.75 2.5C14.3025 2.5 14.8324 2.71949 15.2231 3.11019C15.6138 3.50089 15.8333 4.0308 15.8333 4.58333C15.8333 5.13587 15.6138 5.66577 15.2231 6.05647C14.8324 6.44717 14.3025 6.66667 13.75 6.66667"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RefreshIcon = ({
  color = "#9810FA",
  width = 20,
  height = 20,
  strokeWidth = 1.66667,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 10C2.5 11.4834 2.93987 12.9334 3.76398 14.1668C4.58809 15.4001 5.75943 16.3614 7.12987 16.9291C8.50032 17.4968 10.0083 17.6453 11.4632 17.3559C12.918 17.0665 14.2544 16.3522 15.3033 15.3033C16.3522 14.2544 17.0665 12.918 17.3559 11.4632C17.6453 10.0083 17.4968 8.50032 16.9291 7.12987C16.3614 5.75943 15.4001 4.58809 14.1668 3.76398C12.9334 2.93987 11.4834 2.5 10 2.5C7.90329 2.50789 5.89081 3.32602 4.38333 4.78333L2.5 6.66667"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 2.5V6.66667H6.66667"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CubeWhiteIcon = ({
  color = "white",
  strokeWidth = "3.33333",
  width = "40",
  height = "40",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3333 36.2166C18.8401 36.5092 19.4149 36.6632 20 36.6632C20.5851 36.6632 21.1599 36.5092 21.6667 36.2166L33.3333 29.55C33.8396 29.2577 34.26 28.8375 34.5526 28.3314C34.8451 27.8253 34.9994 27.2512 35 26.6666V13.3333C34.9994 12.7488 34.8451 12.1747 34.5526 11.6686C34.26 11.1625 33.8396 10.7423 33.3333 10.45L21.6667 3.78331C21.1599 3.49075 20.5851 3.33673 20 3.33673C19.4149 3.33673 18.8401 3.49075 18.3333 3.78331L6.66667 10.45C6.16044 10.7423 5.73997 11.1625 5.44744 11.6686C5.1549 12.1747 5.0006 12.7488 5 13.3333V26.6666C5.0006 27.2512 5.1549 27.8253 5.44744 28.3314C5.73997 28.8375 6.16044 29.2577 6.66667 29.55L18.3333 36.2166Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 36.6667V20"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.4834 11.6667L20.0001 20L34.5167 11.6667"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 7.11664L27.5 15.7"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TurnWhiteIcon = ({
  color = "white",
  strokeWidth = "1.66667",
  width = "20",
  height = "20",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 1.66663V9.99996"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.3333 5.5C16.3805 6.54759 17.0941 7.88181 17.384 9.3344C17.6739 10.787 17.5272 12.2929 16.9624 13.6622C16.3975 15.0316 15.4399 16.203 14.2102 17.0287C12.9805 17.8545 11.5338 18.2976 10.0525 18.3023C8.57131 18.3069 7.12187 17.8729 5.88702 17.0548C4.65216 16.2368 3.68718 15.0714 3.11379 13.7056C2.54039 12.3399 2.38425 10.8349 2.66506 9.38051C2.94587 7.92613 3.65105 6.58746 4.69167 5.53333"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CloseCircleGrayIcon = ({
  color = "#4A5565",
  strokeWidth = "1.66667",
  width = "20",
  height = "20",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_88_1658)">
      <path
        d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39762 14.6024 1.66666 10 1.66666C5.39763 1.66666 1.66667 5.39762 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 7.5L7.5 12.5"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 7.5L12.5 12.5"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_88_1658">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CheckCircleGreenIcon = ({
  color = "#008236",
  strokeWidth = "1.66667",
  width = "20",
  height = "20",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 18.3333C14.6024 18.3333 18.3334 14.6024 18.3334 10C18.3334 5.39762 14.6024 1.66666 10 1.66666C5.39765 1.66666 1.66669 5.39762 1.66669 10C1.66669 14.6024 5.39765 18.3333 10 18.3333Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 10L9.16667 11.6667L12.5 8.33334"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ShieldCheckGrayIcon = ({
  color = "#6A7282",
  strokeWidth = "1.33333",
  width = "16",
  height = "16",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6667 10.6667L12 12L14.6667 9.33334"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 6.66665V5.33332C13.9998 5.0995 13.938 4.86986 13.821 4.66743C13.704 4.465 13.5358 4.29689 13.3333 4.17999L8.66667 1.51332C8.46397 1.39629 8.23405 1.33469 8 1.33469C7.76595 1.33469 7.53603 1.39629 7.33333 1.51332L2.66667 4.17999C2.46418 4.29689 2.29599 4.465 2.17897 4.66743C2.06196 4.86986 2.00024 5.0995 2 5.33332V10.6667C2.00024 10.9005 2.06196 11.1301 2.17897 11.3325C2.29599 11.535 2.46418 11.7031 2.66667 11.82L7.33333 14.4867C7.53603 14.6037 7.76595 14.6653 8 14.6653C8.23405 14.6653 8.46397 14.6037 8.66667 14.4867L10 13.7267"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 2.84665L11 6.27998"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.19333 4.66666L8 7.99999L13.8067 4.66666"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 14.6667V8"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ListDotsGrayIcon = ({
  color = "#4A5565",
  strokeWidth = "1.33333",
  width = "16",
  height = "16",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 3.33333H2.00667"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 8H2.00667"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 12.6667H2.00667"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33334 3.33333H14"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33334 8H14"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33334 12.6667H14"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TextRowsGrayIcon = ({
  color = "#6A7282",
  strokeWidth = "1.33333",
  width = "16",
  height = "16",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66666 8H9.33332"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66666 5.33334H9.33332"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33332 14V12C9.33332 11.6464 9.19285 11.3072 8.9428 11.0572C8.69275 10.8071 8.35361 10.6667 7.99999 10.6667C7.64637 10.6667 7.30723 10.8071 7.05718 11.0572C6.80713 11.3072 6.66666 11.6464 6.66666 12V14"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.00001 6.66666H2.66668C2.31305 6.66666 1.97392 6.80713 1.72387 7.05718C1.47382 7.30723 1.33334 7.64637 1.33334 7.99999V12.6667C1.33334 13.0203 1.47382 13.3594 1.72387 13.6095C1.97392 13.8595 2.31305 14 2.66668 14H13.3333C13.687 14 14.0261 13.8595 14.2762 13.6095C14.5262 13.3594 14.6667 13.0203 14.6667 12.6667V5.99999C14.6667 5.64637 14.5262 5.30723 14.2762 5.05718C14.0261 4.80713 13.687 4.66666 13.3333 4.66666H12"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 14V3.33333C4 2.97971 4.14048 2.64057 4.39052 2.39052C4.64057 2.14048 4.97971 2 5.33333 2H10.6667C11.0203 2 11.3594 2.14048 11.6095 2.39052C11.8595 2.64057 12 2.97971 12 3.33333V14"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LocationPinGrayIcon = ({
  color = "#6A7282",
  strokeWidth = "1.33333",
  width = "16",
  height = "16",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 6.66665C13.3333 9.99531 9.64066 13.462 8.40066 14.5326C8.28514 14.6195 8.14452 14.6665 7.99999 14.6665C7.85546 14.6665 7.71484 14.6195 7.59932 14.5326C6.35932 13.462 2.66666 9.99531 2.66666 6.66665C2.66666 5.25216 3.22856 3.8956 4.22875 2.89541C5.22895 1.89522 6.5855 1.33331 7.99999 1.33331C9.41448 1.33331 10.771 1.89522 11.7712 2.89541C12.7714 3.8956 13.3333 5.25216 13.3333 6.66665Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 8.66669C9.10457 8.66669 10 7.77126 10 6.66669C10 5.56212 9.10457 4.66669 8 4.66669C6.89543 4.66669 6 5.56212 6 6.66669C6 7.77126 6.89543 8.66669 8 8.66669Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EyeIcon = ({
  color = "#155DFC",
  strokeWidth = "1.33333",
  width = "16",
  height = "16",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.37468 8.232C1.31912 8.08232 1.31912 7.91767 1.37468 7.768C1.91581 6.4559 2.83435 5.33402 4.01386 4.5446C5.19336 3.75517 6.58071 3.33374 8.00001 3.33374C9.41932 3.33374 10.8067 3.75517 11.9862 4.5446C13.1657 5.33402 14.0842 6.4559 14.6253 7.768C14.6809 7.91767 14.6809 8.08232 14.6253 8.232C14.0842 9.54409 13.1657 10.666 11.9862 11.4554C10.8067 12.2448 9.41932 12.6663 8.00001 12.6663C6.58071 12.6663 5.19336 12.2448 4.01386 11.4554C2.83435 10.666 1.91581 9.54409 1.37468 8.232Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserIcon = ({
  color = "#4F39F6",
  width = 16,
  height = 16,
  strokeWidth = 1.33333,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6666 14V12.6667C12.6666 11.9594 12.3856 11.2811 11.8855 10.781C11.3854 10.281 10.7072 10 9.99992 10H5.99992C5.29267 10 4.6144 10.281 4.1143 10.781C3.6142 11.2811 3.33325 11.9594 3.33325 12.6667V14"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99992 7.33333C9.47268 7.33333 10.6666 6.13943 10.6666 4.66667C10.6666 3.19391 9.47268 2 7.99992 2C6.52716 2 5.33325 3.19391 5.33325 4.66667C5.33325 6.13943 6.52716 7.33333 7.99992 7.33333Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PhoneIcon = ({
  color = "#99A1AF",
  width = 14,
  height = 14,
  strokeWidth = 1.16667,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_118_1814)">
      <path
        d="M8.0685 9.66469C8.18898 9.72002 8.32471 9.73266 8.45332 9.70053C8.58194 9.6684 8.69578 9.59342 8.77609 9.48794L8.98317 9.21669C9.09184 9.07179 9.23276 8.95419 9.39476 8.87319C9.55675 8.79219 9.73539 8.75002 9.9165 8.75002H11.6665C11.9759 8.75002 12.2727 8.87294 12.4915 9.09173C12.7103 9.31052 12.8332 9.60727 12.8332 9.91669V11.6667C12.8332 11.9761 12.7103 12.2729 12.4915 12.4916C12.2727 12.7104 11.9759 12.8334 11.6665 12.8334C8.88173 12.8334 6.21102 11.7271 4.24188 9.75798C2.27275 7.78884 1.1665 5.11813 1.1665 2.33335C1.1665 2.02393 1.28942 1.72719 1.50821 1.5084C1.72701 1.2896 2.02375 1.16669 2.33317 1.16669H4.08317C4.39259 1.16669 4.68934 1.2896 4.90813 1.5084C5.12692 1.72719 5.24984 2.02393 5.24984 2.33335V4.08335C5.24984 4.26447 5.20767 4.44311 5.12667 4.6051C5.04567 4.7671 4.92807 4.90802 4.78317 5.01669L4.51017 5.22144C4.40308 5.30321 4.3276 5.41953 4.29655 5.55064C4.2655 5.68175 4.28079 5.81957 4.33984 5.94069C5.13707 7.55994 6.44825 8.86949 8.0685 9.66469Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_118_1814">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MailIcon = ({
  color = "#99A1AF",
  width = 14,
  height = 14,
  strokeWidth = 1.16667,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8332 4.08331L7.58842 7.42406C7.41044 7.52744 7.20828 7.58189 7.00246 7.58189C6.79664 7.58189 6.59448 7.52744 6.4165 7.42406L1.1665 4.08331"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6665 2.33331H2.33317C1.68884 2.33331 1.1665 2.85565 1.1665 3.49998V10.5C1.1665 11.1443 1.68884 11.6666 2.33317 11.6666H11.6665C12.3108 11.6666 12.8332 11.1443 12.8332 10.5V3.49998C12.8332 2.85565 12.3108 2.33331 11.6665 2.33331Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RedirectIcon = ({
  color = "#6A7282",
  width = 14,
  height = 14,
  strokeWidth = 1.16667,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.75 1.75H12.25V5.25"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.8335 8.16667L12.2502 1.75"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 7.58333V11.0833C10.5 11.3928 10.3771 11.6895 10.1583 11.9083C9.9395 12.1271 9.64275 12.25 9.33333 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V4.66667C1.75 4.35725 1.87292 4.0605 2.09171 3.84171C2.3105 3.62292 2.60725 3.5 2.91667 3.5H6.41667"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DocumentIcon = ({
  color = "#155DFC",
  width = 16,
  height = 16,
  strokeWidth = 1.33333,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_118_1777)">
      <path
        d="M9.99984 1.33334H3.99984C3.64622 1.33334 3.30708 1.47382 3.05703 1.72387C2.80698 1.97392 2.6665 2.31305 2.6665 2.66668V13.3333C2.6665 13.687 2.80698 14.0261 3.05703 14.2762C3.30708 14.5262 3.64622 14.6667 3.99984 14.6667H11.9998C12.3535 14.6667 12.6926 14.5262 12.9426 14.2762C13.1927 14.0261 13.3332 13.687 13.3332 13.3333V4.66668L9.99984 1.33334Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.3335 1.33334V4.00001C9.3335 4.35363 9.47397 4.69277 9.72402 4.94282C9.97407 5.19287 10.3132 5.33334 10.6668 5.33334H13.3335"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66683 6H5.3335"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6668 8.66666H5.3335"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6668 11.3333H5.3335"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_118_1777">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ChatBubbleIcon = ({
  color = "#9810FA",
  width = 16,
  height = 16,
  strokeWidth = 1.33333,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_118_1790)">
      <path
        d="M14.6668 11.3333C14.6668 11.687 14.5264 12.0261 14.2763 12.2761C14.0263 12.5262 13.6871 12.6667 13.3335 12.6667H4.55216C4.19857 12.6667 3.85949 12.8073 3.6095 13.0573L2.1415 14.5253C2.0753 14.5915 1.99097 14.6366 1.89916 14.6548C1.80735 14.6731 1.71218 14.6637 1.6257 14.6279C1.53922 14.5921 1.4653 14.5314 1.41329 14.4536C1.36128 14.3758 1.33351 14.2843 1.3335 14.1907V3.33333C1.3335 2.97971 1.47397 2.64057 1.72402 2.39052C1.97407 2.14048 2.31321 2 2.66683 2H13.3335C13.6871 2 14.0263 2.14048 14.2763 2.39052C14.5264 2.64057 14.6668 2.97971 14.6668 3.33333V11.3333Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_118_1790">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const WarningTriangleIcon = ({
  color = "#F54900",
  width = 20,
  height = 20,
  strokeWidth = 1.66667,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.1085 15L11.4419 3.33333C11.2965 3.07684 11.0857 2.86349 10.831 2.71506C10.5762 2.56662 10.2867 2.48842 9.99185 2.48842C9.69703 2.48842 9.40748 2.56662 9.15275 2.71506C8.89802 2.86349 8.68722 3.07684 8.54185 3.33333L1.87519 15C1.72825 15.2545 1.65121 15.5433 1.65186 15.8371C1.65251 16.1309 1.73083 16.4194 1.87889 16.6732C2.02695 16.927 2.23948 17.1372 2.49493 17.2824C2.75039 17.4276 3.03969 17.5026 3.33352 17.5H16.6669C16.9593 17.4997 17.2465 17.4225 17.4996 17.2761C17.7527 17.1297 17.9629 16.9192 18.1089 16.6659C18.255 16.4126 18.3319 16.1253 18.3318 15.8329C18.3317 15.5405 18.2547 15.2532 18.1085 15Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 7.5V10.8333"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 14.1667H10.0083"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowRightIcon = ({
  color = "white",
  width = 16,
  height = 16,
  strokeWidth = 1.33333,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.3335 8H12.6668"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 3.33331L12.6667 7.99998L8 12.6666"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MoneyBillIcon = ({
  color = "#00A63E",
  width = 24,
  height = 24,
  strokeWidth = 2,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 2V22L6 21L8 22L10 21L12 22L14 21L16 22L18 21L20 22V2L18 3L16 2L14 3L12 2L10 3L8 2L6 3L4 2Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 8H10C9.46957 8 8.96086 8.21071 8.58579 8.58579C8.21071 8.96086 8 9.46957 8 10C8 10.5304 8.21071 11.0391 8.58579 11.4142C8.96086 11.7893 9.46957 12 10 12H14C14.5304 12 15.0391 12.2107 15.4142 12.5858C15.7893 12.9609 16 13.4696 16 14C16 14.5304 15.7893 15.0391 15.4142 15.4142C15.0391 15.7893 14.5304 16 14 16H8"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 17.5V6.5"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DownloadIcon = ({
  color = "#0A0A0A",
  width = 16,
  height = 16,
  strokeWidth = 1.33333,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 10V2"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66669 6.66669L8.00002 10L11.3334 6.66669"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DollarSignIcon = ({
  color = "currentColor",
  width = 24,
  height = 24,
  strokeWidth = 2,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="12" x2="12" y1="2" y2="22" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
);

export const InstagramIcon = ({
  color = "#E60076",
  width = 16,
  height = 16,
  strokeWidth = 1.333,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <g>
      {/* El cuerpo de la cámara (cuadrado redondeado) */}
      <path d="M11.3333 1.33331H4.66668C2.82573 1.33331 1.33334 2.8257 1.33334 4.66665V11.3333C1.33334 13.1743 2.82573 14.6666 4.66668 14.6666H11.3333C13.1743 14.6666 14.6667 13.1743 14.6667 11.3333V4.66665C14.6667 2.8257 13.1743 1.33331 11.3333 1.33331Z" />

      {/* El lente (círculo central) */}
      <path d="M10.6667 7.58002C10.7489 8.13485 10.6542 8.7015 10.3958 9.19936C10.1375 9.69723 9.72877 10.101 9.22776 10.3531C8.72675 10.6053 8.15897 10.6931 7.6052 10.604C7.05143 10.5149 6.53985 10.2534 6.14323 9.85679C5.74662 9.46018 5.48516 8.9486 5.39605 8.39483C5.30694 7.84105 5.39472 7.27328 5.64689 6.77227C5.89907 6.27125 6.3028 5.86251 6.80066 5.60418C7.29853 5.34585 7.86518 5.25108 8.42001 5.33335C8.98596 5.41727 9.50991 5.68099 9.91447 6.08556C10.319 6.49012 10.5828 7.01407 10.6667 7.58002Z" />

      {/* El flash (punto superior derecho) */}
      <path d="M11.6667 4.33331H11.6733" />
    </g>
  </svg>
);

export const FacebookIcon = ({
  color = "#155DFC",
  width = 16,
  height = 16,
  strokeWidth = 1.333,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 1.33331H9.99999C9.11593 1.33331 8.26809 1.6845 7.64297 2.30962C7.01785 2.93474 6.66666 3.78259 6.66666 4.66665V6.66665H4.66666V9.33331H6.66666V14.6666H9.33332V9.33331H11.3333L12 6.66665H9.33332V4.66665C9.33332 4.48984 9.40356 4.32027 9.52859 4.19524C9.65361 4.07022 9.82318 3.99998 9.99999 3.99998H12V1.33331Z" />
  </svg>
);

export const HelpIcon = ({
  color = "white",
  width = 24,
  height = 24,
  strokeWidth = 2,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" />
    <path d="M9.09 8.99999C9.3251 8.33166 9.78915 7.7681 10.4 7.40912C11.0108 7.05015 11.7289 6.91893 12.4272 7.0387C13.1255 7.15848 13.7588 7.52151 14.2151 8.06352C14.6713 8.60552 14.9211 9.29151 14.92 9.99999C14.92 12 11.92 13 11.92 13" />
    <path d="M12 17H12.01" />
  </svg>
);


export const CloseIcon = ({
  color = "white",
  width = 40,
  height = 40,
  strokeWidth = 1.667,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
  >
    <path d="M0 14C0 6.26801 6.26801 0 14 0H26C33.732 0 40 6.26801 40 14V26C40 33.732 33.732 40 26 40H14C6.26801 40 0 33.732 0 26V14Z" fill={color} fillOpacity="0.2" />
    <path d="M25 15L15 25" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 15L25 25" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);


export const YouTubeIcon = ({
  color = "#E7000B",
  width = 28,
  height = 28,
  strokeWidth = 2.333,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 28 28"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M2.91667 19.8333C2.10167 15.9871 2.10167 12.0129 2.91667 8.16667C3.02376 7.77608 3.23067 7.42009 3.51705 7.13371C3.80343 6.84733 4.15942 6.64042 4.55001 6.53333C10.8074 5.4967 17.1927 5.4967 23.45 6.53333C23.8406 6.64042 24.1966 6.84733 24.483 7.13371C24.7693 7.42009 24.9763 7.77608 25.0833 8.16667C25.8983 12.0129 25.8983 15.9871 25.0833 19.8333C24.9763 20.2239 24.7693 20.5799 24.483 20.8663C24.1966 21.1527 23.8406 21.3596 23.45 21.4667C17.1927 22.5035 10.8073 22.5035 4.55001 21.4667C4.15942 21.3596 3.80343 21.1527 3.51705 20.8663C3.23067 20.5799 3.02376 20.2239 2.91667 19.8333Z" />
    <path d="M11.6667 17.5L17.5 14L11.6667 10.5V17.5Z" />
  </svg>
);

export const BookIcon = ({
  color = "#00A63E",
  width = 28,
  height = 28,
  strokeWidth = 2.333,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 28 28"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Línea central del libro */}
    <path d="M14 8.16669V24.5" />

    {/* Contorno de las páginas */}
    <path d="M3.50001 21C3.19059 21 2.89384 20.8771 2.67505 20.6583C2.45626 20.4395 2.33334 20.1428 2.33334 19.8333V4.66667C2.33334 4.35725 2.45626 4.0605 2.67505 3.84171C2.89384 3.62292 3.19059 3.5 3.50001 3.5H9.33334C10.571 3.5 11.758 3.99167 12.6332 4.86683C13.5083 5.742 14 6.92899 14 8.16667C14 6.92899 14.4917 5.742 15.3668 4.86683C16.242 3.99167 17.429 3.5 18.6667 3.5H24.5C24.8094 3.5 25.1062 3.62292 25.325 3.84171C25.5438 4.0605 25.6667 4.35725 25.6667 4.66667V19.8333C25.6667 20.1428 25.5438 20.4395 25.325 20.6583C25.1062 20.8771 24.8094 21 24.5 21H17.5C16.5718 21 15.6815 21.3687 15.0251 22.0251C14.3688 22.6815 14 23.5717 14 24.5C14 23.5717 13.6313 22.6815 12.9749 22.0251C12.3185 21.3687 11.4283 21 10.5 21H3.50001Z" />
  </svg>
);

export const PlayIcon = ({
  color = "#C10007",
  width = 16,
  height = 16,
  strokeWidth = 1.333,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3.33334 3.33336C3.33327 3.09876 3.39511 2.86829 3.5126 2.66522C3.63009 2.46216 3.79908 2.29369 4.00251 2.17683C4.20594 2.05996 4.4366 1.99885 4.6712 1.99964C4.90581 2.00044 5.13605 2.06312 5.33868 2.18136L13.3367 6.8467C13.5385 6.96382 13.7061 7.13186 13.8226 7.33403C13.9392 7.5362 14.0006 7.76543 14.0008 7.99879C14.001 8.23215 13.94 8.46148 13.8238 8.66385C13.7076 8.86623 13.5403 9.03456 13.3387 9.15203L5.33868 13.8187C5.13605 13.9369 4.90581 13.9996 4.6712 14.0004C4.4366 14.0012 4.20594 13.9401 4.00251 13.8232C3.79908 13.7064 3.63009 13.5379 3.5126 13.3348C3.39511 13.1318 3.33327 12.9013 3.33334 12.6667V3.33336Z" />
  </svg>
);


export const ChefHatIcon = ({
  color = "currentColor",
  width = 24,
  height = 24,
  strokeWidth = 2,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17 21a1 1 0 0 0 1-1v-5.35c0-.457.316-.844.727-1.041a4 4 0 0 0-2.134-7.589 5 5 0 0 0-9.186 0 4 4 0 0 0-2.134 7.588c.411.198.727.585.727 1.041V20a1 1 0 0 0 1 1Z" />
    <path d="M6 17h12" />
  </svg>
);

export const MotorbikeIcon = ({
  color = "currentColor",
  width = 24,
  height = 24,
  strokeWidth = 2,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="m18 14-1-3" />
    <path d="m3 9 6 2a2 2 0 0 1 2-2h2a2 2 0 0 1 1.99 1.81" />
    <path d="M8 17h3a1 1 0 0 0 1-1 6 6 0 0 1 6-6 1 1 0 0 0 1-1v-.75A5 5 0 0 0 17 5" />
    <circle cx="19" cy="17" r="3" />
    <circle cx="5" cy="17" r="3" />
  </svg>
);

export const TimerIcon = ({
  color = "currentColor",
  width = 24,
  height = 24,
  strokeWidth = 2,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="10" x2="14" y1="2" y2="2" />
    <line x1="12" x2="15" y1="14" y2="11" />
    <circle cx="12" cy="14" r="8" />
  </svg>
);